import { FETCH_CURRENCY, UPDATE_CURRENCY } from "../../actions/actionTypes";

export const currencyReducer = (state = {}, action) => {
    if (action && action.payload && !action.payload.errors) {
      switch (action.type) {
        case FETCH_CURRENCY:
          const fetchedCurrency = action.payload.customerCurrency || "";
          const newState = {
            ...state,
            customerCurrency: fetchedCurrency
          };
          return newState;

        case UPDATE_CURRENCY:
          const updatedCurrency = action.payload.customerCurrency;
          const updatedState = {
            ...state,
            customerCurrency: updatedCurrency
          };
          return updatedState;

        default:
          return state;
      }
    } else {
      return state;
    }
  };

